"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgKeepAlive = void 0;
class MsgKeepAlive {
    constructor(init) {
        this.Dummy = 69;
        Object.assign(this, init);
    }
}
exports.MsgKeepAlive = MsgKeepAlive;
